import { PageShell } from "@/components/PageShell";
import { LegalPage } from "@/components/LegalPage";
import { ArrowRight } from "lucide-react";

const ExclusaoDeDados = () => {
  return (
    <PageShell>
      <LegalPage title="Solicitação de Exclusão de Dados">
        <p>
          A RODE IA disponibiliza um canal para solicitações de exclusão de
          dados pessoais relacionados aos seus serviços.
        </p>

        <h2>Para solicitar</h2>
        <ol>
          <li>
            envie um e-mail para{" "}
            <a href="mailto:privacidade@rodeia.com.br">
              privacidade@rodeia.com.br
            </a>
            ;
          </li>
          <li>use o assunto "Solicitação de exclusão de dados";</li>
          <li>
            informe somente os dados necessários para identificarmos a relação
            ou serviço relacionado ao pedido.
          </li>
        </ol>
        <p>
          Não solicitamos senha, token, código de autenticação ou outro segredo.
        </p>

        <h2>Verificação e prazos</h2>
        <p>
          Podemos solicitar informações adicionais para confirmar a identidade
          do solicitante e evitar exclusões indevidas.
        </p>
        <p>
          Após a validação do pedido, os dados elegíveis serão excluídos ou
          anonimizados conforme aplicável. Determinadas informações poderão ser
          mantidas quando sua retenção for necessária para cumprimento de
          obrigação legal, exercício de direitos ou segurança.
        </p>
        <p>
          Este canal também pode ser utilizado para solicitações relacionadas a
          dados tratados por integrações com plataformas como Meta e WhatsApp,
          quando aplicável.
        </p>

        <div className="pt-6">
          <a
            href="mailto:privacidade@rodeia.com.br?subject=Solicita%C3%A7%C3%A3o%20de%20exclus%C3%A3o%20de%20dados"
            data-testid="exclusao-button"
            className="group inline-flex items-center justify-center gap-2 bg-white text-black font-semibold px-7 py-4 rounded-sm hover:bg-neutral-200 active:scale-95 transition-all no-underline"
          >
            Solicitar exclusão de dados
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>

        <p className="pt-8 font-mono text-xs text-neutral-500">
          RODE IA LTDA
          <br />
          CNPJ 68.764.921/0001-64
        </p>
      </LegalPage>
    </PageShell>
  );
};

export default ExclusaoDeDados;
